(function () {
    class AjaxTracy {
        constructor(maxRequests, maxVisibleRows) {
            this.counter = 0;
            this.requests = [];
            this.maxRequests = maxRequests || 50;
            this.maxVisibleRows = maxVisibleRows || 5;
            this.debug = document.getElementById("tracy-debug");
            this.bar = document.getElementById("tracy-debug-bar");

            if (!this.debug) console.warn("Not founded div with id: #tracy-debug");
            if (!this.bar) console.warn("Not founded div with id: #tracy-debug-bar");

            if (!this.debug || !this.bar) return;

            if (this.maxVisibleRows > 0) {
                this.bar.style.overflowY = "auto";
                this.bar.style.maxHeight = (this.maxVisibleRows * 21) + "px";
            }
        }

        handleRequest(response) {
            if (!this.debug || !this.bar) return;

            let result = {};

            if (response.responseText) {
                try {
                    result = JSON.parse(response.responseText);
                } catch (err) {
                    return console.warn(err.message);
                }
            }

            if (!result.tracy) return;

            if (this.counter === this.maxRequests) {
                let rows = this.bar.querySelectorAll("ul[id]");
                rows.forEach((row) => {
                    row.remove();
                });
                this.requests = [];
                this.counter = 0;
            }

            this.addRowToBar(result.tracy);
            this.requests.push(result.tracy);
            this.counter++;
        }

        addRowToBar(panels) {
            if (!this.debug || !this.bar) return;

            let row = document.createElement("ul");
            row.id = "tracyRow/" + this.counter;
            row.classList.add("tracy-previous");
            row.innerHTML += '<li><span><span>AJAX</span></span></li>';

            for (let name in panels) {
                let value = panels[name];
                let tab = '<li><a href="#" data-tracy="tab" data-id="' + this.counter + '" data-name="' + name + '" data-ajax="off">' + value.tab + "</a></li>";
                row.innerHTML += tab;
            }

            row.innerHTML += '<li><a href="#" data-tracy="closeRow" data-ajax="off">X</a></li>';

            this.bar.insertBefore(row, this.bar.childNodes[0]);
            this._initEvents(row);
        }

        addPanel(link) {
            if (!this.debug || !this.bar) return;

            let id = Number(link.dataset.id);
            let name = link.dataset.name;
            let req = this.requests[id];

            let floatPanel = document.getElementById("tracy-debug-panel-" + id + "-" + name);
            if (floatPanel) return;

            if (req && req[name]) {
                let panelHtml = req[name].panel;
                let panel = document.createElement("div");
                panel.id = "tracy-debug-panel-" + id + "-" + name;
                panel.style.bottom = this.bar.offsetHeight + "px";
                panel.className = "tracy-panel tracy-mode-float";
                panel.innerHTML = panelHtml;
                panel.Tracy = {};

                let icons = document.createElement("div");
                icons.className = "tracy-icons";
                icons.innerHTML = '<a href="#" rel="close">x</a>';
                icons.onclick = () => {
                    panel.remove();
                };

                panel.appendChild(icons);
                this.debug.appendChild(panel);

                if (!window.Tracy) return false;
                let tPanel = new Tracy.DebugPanel(id + "-" + name);
                tPanel.init();
                tPanel.toFloat();
            }
        }

        _initEvents(row) {
            let links = row.querySelectorAll('[data-tracy="tab"]');
            links.forEach((link) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.addPanel(link);
                });
            });

            let close = row.querySelector('[data-tracy="closeRow"]');
            if (!close) return;
            close.addEventListener("click", (e) => {
                e.preventDefault();
                row.remove();
            });
        }
    }

    window.AjaxTracy = AjaxTracy;
})();
